import { Component, Input, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'quest-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.css']
})

export class BarComponent implements  AfterViewInit  {

  constructor(private render: Renderer2) {
  }

  @ViewChild('barValue', { static: false }) el: ElementRef;
  @Input() Text: string;
  @Input() Value: number;
  @Input() MaxValue: number;
  @Input() Color: number;
  @Input() ChartType: string;
  ngAfterViewInit() {

 
    const percentage = (this.Value * 100 )/ this.MaxValue;
    this.render.setStyle(this.el.nativeElement, "width", `${percentage}%`);

    if (this.ChartType === 'SATISFACTION') {
      const color = ['#FF3838', '#EF7B39', '#E0B23A', '#C3D03B', '#85C13A'];
      this.render.setStyle(this.el.nativeElement, "background-color", color[parseInt(this.Text)-1])
    } else {
      const color = ['#2077B4', '#FF7F0E', '#2DA02C', '#D62728', '#9366BE', '#8C554A', '#E377C3', '#7F7F7F', '#BCBD22', '#17BECF'];
      this.render.setStyle(this.el.nativeElement, "background-color", color[Math.abs(this.Color % 10)])
    }
  }
}
